/**
 * useLineOffersComment — whether this line's brief belongs on the editing page.
 *
 * The rule itself lives in `productCommentSurface`, so the drawer and this page
 * read one answer and cannot both offer a box for the same `CartItem.note`. This
 * hook only resolves the line back to its catalogue entry, the way
 * `useVariantCollectsAiSettings` does for the sky settings.
 */

import type { CartItemId } from 'models/purchaseFlowRevamp'

import { useCartLineCatalogueEntry } from '../useCartLineCatalogueEntry'
import { productCommentSurface } from '../../components/productDrawer/productComment'

export function useLineOffersComment(cartItemId: CartItemId): boolean {
  const { shell, variant } = useCartLineCatalogueEntry(cartItemId)
  if (!shell) return false
  return productCommentSurface({
    categoryId: shell.categoryId,
    kind: variant?.kind ?? shell.kind,
    configurationFlows: shell.configurationFlows,
  }) === 'configuration'
}
